/**
 * @class
 */
import Base from '@netx/core/lib/netx-collection';
import Model from '../models/samlService';

class SAMLServices extends Base {
	/** @override */
	constructor(models, opts = {}) {
		opts.model = opts.model || Model;
		super(models, opts);
	}

	/** @type {string} */
	static get __name__() {
		return 'SAMLServices';
	}
}

export default SAMLServices;
